import { AccountPageTabsEnum } from '@entities/account';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface StatesSliceState {
  selectedBet?: string;
  gameFinding: {
    gameId?: string;
    loading: boolean;
  };
  gameRestarting: boolean;
  accountSelectedTab: AccountPageTabsEnum;
}

const initialState: StatesSliceState = {
  gameFinding: {
    loading: false,
  },
  gameRestarting: false,
  selectedBet: undefined,
  accountSelectedTab: AccountPageTabsEnum.KYC,
};

const statesSlice = createSlice({
  name: 'states',
  initialState,
  reducers: {
    setSelectedBet: (state, { payload }: PayloadAction<string | undefined>) => {
      state.selectedBet = payload;
    },
    setGameFindingStart: (state) => {
      state.gameFinding.gameId = undefined;
      state.gameFinding.loading = true;
    },
    setGameFindingEnd: (state, { payload }: PayloadAction<{ gameId?: string }>) => {
      state.gameFinding.gameId = payload.gameId;
      state.gameFinding.loading = false;
    },
    setGameRestarting: (state, { payload }: PayloadAction<boolean>) => {
      state.gameRestarting = payload;
    },
    setAccountSelectedTab: (state, { payload }: PayloadAction<AccountPageTabsEnum>) => {
      state.accountSelectedTab = payload;
    },
  },
});

export const {
  setSelectedBet,
  setGameFindingEnd,
  setGameRestarting,
  setGameFindingStart,
  setAccountSelectedTab,
} = statesSlice.actions;

export default statesSlice.reducer;
